var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41069 1.07797C9.56696 0.921747 9.77888 0.833984 9.99985 0.833984C10.2208 0.833984 10.4327 0.921747 10.589 1.07797L15.589 6.07797C15.7408 6.23514 15.8248 6.44564 15.8229 6.66414C15.821 6.88264 15.7334 7.09165 15.5789 7.24615C15.4244 7.40066 15.2153 7.4883 14.9969 7.4902C14.7784 7.4921 14.5679 7.4081 14.4107 7.25631L10.8332 3.67881L10.8332 18.3338C10.8332 18.5548 10.7454 18.7668 10.5891 18.9231C10.4328 19.0793 10.2209 19.1671 9.99985 19.1671C9.77884 19.1671 9.56688 19.0793 9.4106 18.9231C9.25432 18.7668 9.16652 18.5548 9.16652 18.3338L9.16652 3.67881L5.58902 7.25631C5.43185 7.4081 5.22135 7.4921 5.00285 7.4902C4.78435 7.4883 4.57534 7.40066 4.42084 7.24615C4.26633 7.09165 4.17869 6.88264 4.17679 6.66414C4.17489 6.44564 4.25889 6.23514 4.41068 6.07797L9.41069 1.07797Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon-up.bf7fe719ece06387c3a30c37826ed52d.svg";
export { ForwardRef as ReactComponent };